import Auth0Lock from 'auth0-lock'
import decode from 'jwt-decode'
import router from './router'
import store from './store'
import Vue from 'vue'

export const AUTH_CONFIG = {
  clientId: process.env.VUE_APP_AUTH0_CLIENTID,
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  callbackURL: process.env.VUE_APP_AUTH0_CALLBACKURL,
  apiUrl: process.env.VUE_APP_AUTH0_APIURL,
  scope: process.env.VUE_APP_AUTH0_SCOPE,
  responseType: process.env.VUE_APP_AUTH0_RESPONSETYPE,
}

class AuthService {
  idToken
  accessToken
  expiresAt
  authenticated = this.isAuthenticated()
  admin = this.isAdmin()
  userProfile

  constructor () {
    this.lock.on('authenticated', this.setSession.bind(this))
    this.lock.on('authorization_error', error => console.log(error))

    try {
      if(this.getAccessToken() === true){
      //  store.commit('SET_CURRENT_USER', this.userProfile)
      }
    }
    catch {}
  }

  lock = new Auth0Lock(AUTH_CONFIG.clientId, AUTH_CONFIG.domain, {
    autoclose: true,
    auth: {
      audience: AUTH_CONFIG.apiUrl,
      redirectUrl: AUTH_CONFIG.callbackURL,
      responseType: AUTH_CONFIG.responseType,
      params: {
        scope: AUTH_CONFIG.scope
      }
    }
  })

  login () {
    this.lock.show()
  }

  setSession (authResult) {

    console.log('setSession')

    if (authResult && authResult.accessToken && authResult.idToken) {
      // Set the time that the access token will expire at
      const expiresAt = JSON.stringify(
        authResult.expiresIn * 1000 + new Date().getTime()
      )

      this.idToken = authResult.idToken
      this.accessToken = authResult.accessToken
      this.expiresAt = expiresAt
      this.userProfile = authResult.idTokenPayload
      localStorage.setItem('loggedIn', true)

      Object.assign(Vue.prototype.$spinnaApi.defaults, {headers: {'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.idToken}});
      Object.assign(Vue.prototype.$userApi.defaults, {headers: {'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.accessToken}});

      store.commit('SET_CURRENT_USER', authResult.idTokenPayload)

      if( store.state.user_id !== false ){
        store.dispatch('GET_ALL_PROJECTS')
        store.dispatch('GET_ALL_PHRASES')
      }

      //this.authNotifier.emit('authChange', { authenticated: true, admin: this.isAdmin() })
      router.replace({ name: 'secureHome', params: {locale: 'de_de'} })
    }
  }

  getAccessToken () {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      throw new Error('No access token found')
    }
    return accessToken
  }

  getProfile (cb) {
    const accessToken = this.getAccessToken()

    this.lock.getUserInfo(accessToken, (err, profile) => {
      if (profile) {
        this.userProfile = profile
      }
      cb(err, profile)
    })
  }

  renewSession () {

    console.log('renewSession')

    if (localStorage.getItem('loggedIn') === 'true') {
      this.lock.checkSession({ redirectUri: AUTH_CONFIG.callbackURL }, (err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          console.log('SESSION RENEWED')
          this.setSession(authResult)
        } else if (err) {
          this.logout()
          console.log('LOGOUT HERE')
          console.log(err)
          alert(`Could not get a new token (${err.error}: ${err.error_description}).`)
        }
      })
    }
  }

  logout () {
    // Clear access token and ID token from local storage
    this.idToken = null
    this.accessToken = null
    this.expiresAt = null
    this.userProfile = null

    //this.authNotifier.emit('authChange', false)

    localStorage.removeItem('loggedIn')

    Object.assign(Vue.prototype.$spinnaApi.defaults, {headers: {'Content-Type': 'application/json', 'authorization': ''}});
    Object.assign(Vue.prototype.$userApi.defaults, {headers: {'Content-Type': 'application/json', 'authorization': ''}});


    store.commit('SET_CURRENT_USER', false)
    router.replace({ name: 'publicHome', params: {locale: 'de_de'} })
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    const isLoggedIn = localStorage.getItem('loggedIn') === 'true'
    return this.expiresAt && isLoggedIn && new Date().getTime() < this.expiresAt
  }

  getRole () {
    const namespace = 'https://example.com'
    const idToken = this.idToken

    if (idToken) {
      return decode(idToken)[`${namespace}/role`] || null
    }
  }

  isAdmin () {
    return this.getRole() === 'admin'
  }
}


export default {
  install: function(Vue) {
    Vue.prototype.$auth = new AuthService()
  }
}
